import { Component, ojs, app, each } from "modular-openscriptjs";
import {
	pageInfo,
	either,
	inform
} from "../../helpers";
import { dom } from "../../fotastart";
import { PAGES, STRINGS } from "../../declarations";

const h = app("h");
const broker = app("broker");
const $e = app("$e");
const uc = app("uc");

export default class Setting extends Component {
    render(...args) {
        pageInfo(PAGES.SETTINGS);

        return h.div(
            { class: "container pb-5 my-5 pt-3 py-md-5" },

            h.Card({
                title: "Push Notifications",
                body: [
                    h.div(
                        { class: "form-check form-switch" },
                        h.label(
                            {
                                class: "form-check-label",
                                for: "settings-turn-on-notification",
                            },
                            "Receive App Notifications"
                        ),
                        h.input(
                            {
                                class: "form-check-input",
                                type: "checkbox",
                                role: "switch",
                                id: "settings-turn-on-notification",
                                onclick: this.method("turnOnNotification"),
                            },
                            either(
                                "Notification" in window &&
                                    Notification.permission === "granted",
                                { checked: true }
                            )
                        ),
                        h.div(
                            { class: "form-text" },
                            "Receive notifications for order information, completion codes, app changes, and others"
                        )
                    ),
                ],
            }, {class: "mb-4"}),

            h.call(() => {
                const settings = uc.settings;
                return each(settings.value, (setting) =>
                    h.SettingItem(setting, { class: "mb-4" })
                );
            }),

            ...args
        );
    }

    turnOnNotification() {
        if (
            !("Notification" in window) ||
            Notification.permission === "granted"
        )
            return;

        broker.send($e.system.needs.notificationPermission);
    }

    $$system = {
        has: {
            notificationPermission: (ed, event) => {
                if (!("Notification" in window)) return;
                if (!dom.id("settings-turn-on-notification")) return;

                if (Notification.permission === "granted") {
                    dom.id("settings-turn-on-notification").checked = true;

                    return;
                }

                if (Notification.permission === "denied") {
                    inform(
                        "Oops! Notification is blocked. Please use chrome site settings to reset it",
                        STRINGS.WARNING
                    );
                }

                dom.id("settings-turn-on-notification").checked = false;
            },
        },
    };
}

ojs(Setting);
